import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const [isAuth, setIsAuth] = useState(null); // null = loading

  useEffect(() => {
    fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/admin-auth`, {
      credentials: 'include',
    })
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error('Not authorized');
      })
      .then(() => setIsAuth(true))
      .catch(() => setIsAuth(false));
  }, []);
  console.log(isAuth);
  if (isAuth === null) return <div>Loading...</div>;
  if (!isAuth) return <Navigate to="/admin" replace />;

  return children;
}
